/* eslint camelcase: 0 */
import { toPaymentProps } from './payment'
import { Order, UpdateOrderRequest } from '@/infrastructure/network/Monitaro/schema/models'
import { IOrderProps, EmptyOrderPropsFactory } from '@/entities/Order'

export const toOrderProps = (props: Order | null | undefined): IOrderProps => {
  if (!props) {
    return EmptyOrderPropsFactory()
  }

  const {
    id,
    user_id,
    payments,
    title,
    payment,
    status,
    amount,
    subtotal,
    commission,
    tax,
    gmo_order_no,
    gmo_access_no,
    gmo_access_pass,
    gmo_branch_no,
    gmo_card_no,
    gmo_conf_no,
    gmo_receipt_no,
    gmo_receipt_url,
    gmo_tran_no,
    gmo_tran_date,
    gmo_convenience_no,
    confirmed,
    properties,
    started_at,
    ended_at,
    sent_at,
    created_at,
    updated_at
  } = props

  return EmptyOrderPropsFactory({
    id,
    userId: user_id,
    payments: payments?.map(toPaymentProps),
    title,
    payment,
    status,
    amount,
    subtotal,
    commission,
    tax,
    gmoOrderNo: gmo_order_no,
    gmoAccessNo: gmo_access_no,
    gmoAccessPass: gmo_access_pass,
    gmoBranchNo: gmo_branch_no,
    gmoCardNo: gmo_card_no,
    gmoConfNo: gmo_conf_no,
    gmoReceiptNo: gmo_receipt_no,
    gmoReceiptUrl: gmo_receipt_url,
    gmoTranNo: gmo_tran_no,
    gmoTranDate: gmo_tran_date,
    gmoConvenienceNo: gmo_convenience_no,
    confirmed,
    properties,
    startedAt: started_at,
    endedAt: ended_at,
    sentAt: sent_at,
    createdAt: created_at,
    updatedAt: updated_at
  })
}

export const toUpdateOrderRequest = (props: IOrderProps): UpdateOrderRequest => {
  const { id, payment } = props
  return {
    id: id!,
    payment: payment!
  }
}
